export default __webpack_public_path__ + "static/media/signup-background.6b33809b.jpeg";